module.exports = __webpack_public_path__ + "media/images/gameLogo-f27c7e54c47974c07d7532268286e1be.png";